import React from "react";
import Cropper from "react-easy-crop";
import { useImageState } from "./image-state";
import ErrorPrompt from "../../prompt/error";

export default function SingleImgPreview({
  accept,
  uploadedFile,
  callback,
  children,
}: {
  accept?: string;
  uploadedFile: any;
  callback: any;
  children: any;
}) {
  const {
    inputRef,
    fileObj,
    isFileSelect,
    selectFile,
    handleFileChange,
    crop,
    setCrop,
    zoom,
    setZoom,
    setIsFileSelect,
    onCropComplete,
    cropImage,
    apiError,
    setApiError,
    handleDragOver,
    handleDrop,
  } = useImageState(uploadedFile, callback);

  return (
    <>
      <div
        className="h-full w-full"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <div className="cursor-pointer h-full w-full" onClick={selectFile}>
          {children}
          <input
            aria-label="File"
            type="file"
            ref={inputRef}
            className="hidden"
            onChange={handleFileChange}
            accept={accept ?? "image/*"}
          />
          <img
            src={fileObj}
            alt="Selected Image"
            id="selectedImage"
            className="hidden"
          />
        </div>
      </div>
      {isFileSelect && (
        <div className="h-screen fixed left-0 top-0 w-full bg-black bg-opacity-50 flex justify-center items-center text-font-primary z-[101]">
          <Cropper
            image={fileObj}
            crop={crop}
            zoom={zoom}
            aspect={1 / 1}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          />
          <div className="absolute bottom-10 lg:bottom-0 w-full flex justify-between text-font-primary mb-5 select-none">
            <button
              type="button"
              onClick={() => setIsFileSelect(false)}
              className="border border-font-primary rounded-full py-2 px-4 ml-5 bg-surface"
            >
              Cancel
            </button>
            <button
              type="button"
              className="border border-font-primary rounded-full py-2 px-4 mr-5 bg-surface"
              onClick={cropImage}
            >
              Done
            </button>
          </div>
        </div>
      )}
      {apiError && (
        <ErrorPrompt error={apiError} onClose={() => setApiError(null)} />
      )}
    </>
  );
}
